import React, { useMemo } from 'react'
import qs from 'qs'
import Places from 'constants/places'
import HotelPageCategoryTile from './HotelPageCategoryTile'
import { CategoryData } from './types'

interface Props {
  category: CategoryData;
}

function generateCategorySearchUrl(category: CategoryData): string {
  const { parameterName, parameterValue } = category

  if (parameterName === 'link' && typeof parameterValue === 'string') {
    return parameterValue
  }

  let parameters: Record<string, string> = {}

  if (Array.isArray(parameterValue) && Array.isArray(parameterName)) {
    // Ensure both arrays have the same length
    if (parameterValue.length !== parameterName.length) {
      throw new Error('parameterName and parameterValue arrays must have the same length')
    }

    parameters = parameterName.reduce<Record<string, string>>((acc, name, index) => {
      acc[name] = parameterValue[index]
      return acc
    }, {})
  } else if (typeof parameterValue === 'string' && typeof parameterName === 'string') {
    parameters = { [parameterName]: parameterValue }
  }

  const queryString = qs.stringify({
    destinationId: Places.Anywhere.id,
    destinationName: Places.Anywhere.name,
    ...parameters,
    adults: 2,
    children: 'none',
  }, {
    arrayFormat: 'comma',
  })

  return `/search?${queryString}`
}

function HotelPageSearchHotelCategoryTile(props: Props) {
  const { category } = props

  const categorySearchUrl = useMemo(() => generateCategorySearchUrl(category), [category])

  return <HotelPageCategoryTile
    toUrl={categorySearchUrl}
    category={category}
    actionText="View offers"
  />
}

export default HotelPageSearchHotelCategoryTile
